import AppList, {AppListConfig} from "../../../../../components/layout/list";
import {Salary, SalaryRestControllerApiFactory,} from "arteco-api-client-ts";
import React from "react";
import {useApiManager} from "../../../../../components/utils/api";
import {useParams} from "react-router-dom";
import {usePerson} from "../index";
import {parsePathId} from "../../../../../components/form/form_utils";
import {TableCell, Typography} from "@mui/material";
import {dateToString} from "../../../../../components/utils/dates";
import {euros, SoftChip} from "../../../../../components/kit";
import {personName} from "../header";

const num = {fontVariantNumeric: "tabular-nums"} as const;

export const SalaryListPage = () => {
	const params = useParams();
	const apiManager = useApiManager();


	const personId = parsePathId(params, "personId");
	const [person, setPerson] = usePerson(personId);

	const salaryCtrl = apiManager.factory(SalaryRestControllerApiFactory);


	const listConfig: AppListConfig<Salary> = {
		title: "Salarios de " + personName(person),
		onClick: "/app/admin/employee/person/" + person?.id + "/salary",
		headers: [
			{title: "Desde"},
			{title: "Salario anual", align: "right"},
			{title: "Tarifa €/h", align: "right"},
			{title: "Coste €/h", align: "right"},
			{title: "Rol"},
			{title: "Nivel"},
		],
		decorator: (bean: Salary) =>
			<>
				<TableCell><Typography variant="body2" fontWeight={600}>{dateToString(bean.startDate)}</Typography></TableCell>
				<TableCell align="right" sx={num}>{euros(bean.annualSalary)}</TableCell>
				<TableCell align="right" sx={num}>{euros(bean.avgHourRate)}</TableCell>
				<TableCell align="right" sx={{...num, color: bean.hourlyCost && bean.avgHourRate && bean.hourlyCost > bean.avgHourRate ? "error.main" : undefined}}>
					{euros(bean.hourlyCost)}
				</TableCell>
				<TableCell>{bean.role ? <SoftChip tone="info" label={bean.role}/> : "—"}</TableCell>
				<TableCell>{bean.roleLevel || "—"}</TableCell>
			</>,
		supplier: async (currentPage, size, term, showDismissed) => {
			if (personId) {
				return salaryCtrl.pageSalary(
					personId,
					currentPage,
					size,
					undefined,
					undefined,
					term,
					showDismissed
				);
			} else {
				throw new Error("PersonId is null");
			}
		},
	};

	return (
		<>
			<AppList config={listConfig}/>
		</>
	);
};